import React, { useCallback, useMemo, useState } from 'react';
import './styles.scss';
import { HeaderCommon, Spin } from 'components/Atoms';
import cn from 'classnames';
import { Col, Empty, Row } from 'antd';
import { ModalListDemographic } from '..';
import { useGetDemographicList } from 'components/Pages/Library/components/Audiences/services';
import { FormattedMessage } from 'react-intl';

const COLS_IN_ROWS = {
  1: { xs: 24 },
  2: { xs: 24, md: 12 },
};

const DemographicItem = ({ name, items }) => {
  return (
    <div className="demographic-item">
      <div className="parent-name fz-16 fw-600">{name}</div>
      <Row className="mt-20 px-20" gutter={[20, 20]}>
        {items.map((i) => (
          <Col key={i.id} span={12}>
            <div className="child-item">
              <div className="dot" />
              <div>
                <span className="child-name">{i.name}</span>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

const ListDemographic = ({
  showHeader = true,
  demographics = [],
  className,
  showLimit = 12,
  isModal = false,
  colsInRow = 1,
  showEmpty = true,
  serviceList = useGetDemographicList,
  title,
}) => {
  const [visible, setVisible] = useState(false);
  const {
    data: { demographicObj },
    isFetching,
  } = serviceList();

  const filterDemographics = useMemo(() => {
    if (demographics?.length && Object.keys(demographicObj)?.length) {
      return demographics.filter(
        (id) =>
          !demographicObj[id]?.items || demographicObj[id]?.items?.length === 0
      );
    }
    return [];
  }, [demographics, demographicObj]);

  const filterDemographicsWithLimit = useMemo(() => {
    return filterDemographics.slice(0, showLimit);
  }, [showLimit, filterDemographics]);

  const getRootParentChildObj = useMemo(() => {
    if (
      Object.keys(demographicObj).length &&
      filterDemographicsWithLimit.length
    ) {
      return filterDemographicsWithLimit.reduce((acc, cur) => {
        const parentIds = demographicObj[cur]?.parentIds || [];
        if (parentIds.length) {
          const rootParentId = parentIds[0];
          if (!acc[rootParentId]) {
            acc[rootParentId] = [];
          }
          acc[rootParentId].push(cur);
        }
        return acc;
      }, {});
    }
    return {};
  }, [demographicObj, filterDemographicsWithLimit]);

  const _renderDemographicItem = ([parentId, itemIds]) => {
    return (
      <Col key={parentId} {...COLS_IN_ROWS[colsInRow]}>
        <DemographicItem
          name={demographicObj[parentId].name}
          items={itemIds.map((id) => demographicObj[id])}
        />
      </Col>
    );
  };

  return (
    <div className={cn('list-demographic-wrapper h-100p', className)}>
      {showHeader && (
        <HeaderCommon className="p-20" title={title}>
          {filterDemographics.length > showLimit && (
            <div
              className="f-right t-right fw-600 fz-16 text-dark-gray action"
              onClick={() => setVisible(true)}
            >
              <span><FormattedMessage id="list_campaign.see_all" defaultMessage="See all" /></span>
            </div>
          )}
        </HeaderCommon>
      )}
      <div className={cn('px-20 py-30', { 'scroll-y h-690': isModal })}>
        {!filterDemographics.length && !isFetching && showEmpty && (
          <Empty description="No Demographic" />
        )}
        {!filterDemographics.length && isFetching && <Spin />}
        <Row gutter={[30, 30]} className={cn({ 'px-50 py-10': isModal })}>
          {Object.entries(getRootParentChildObj).map(_renderDemographicItem)}
        </Row>
      </div>
      <ModalListDemographic
        visible={visible}
        onClose={() => setVisible(false)}
        demographics={demographics}
        serviceList={serviceList}
        title={title}
      />
    </div>
  );
};

export default ListDemographic;
